<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="assign-retention-touchpoint-modal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <form @submit.prevent="submit">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">
                &times;
              </span>
            </button>

            <h4 class="modal-title">
              Assign Touchpoint Task
            </h4>
          </div>

          <div class="modal-body">
            <SelectFormGroup
                v-model="selectedUserId"
                name="user_id"
                label="Assign to"
                :error="getError('user_id')"
                :options="userOptions"
            />
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>

            <button type="submit" class="btn btn-black">
              <i class="fa fa-save"></i> Assign
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import Errors from '@/mixins/Errors'
import SelectFormGroup from '@/vendor/forms/FormGroups/Block/Select'

export default {
  components: { SelectFormGroup },

  mixins: [Errors],

  props: {
    task: {
      required: false,
      default: null
    },
    users: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      selectedUserId: null
    }
  },

  computed: {
    userOptions() {
      const options = this.users.map(user => ({
        value: user.id,
        label: user.attributes.full_name
      }))

      // Optionally add an "Unassigned" option if your backend supports nulling it out
      options.unshift({ value: null, label: '(Unassigned)' })

      return options
    }
  },

  watch: {
    task() {
      if (this.task) {
        this.selectedUserId = this.task.attributes.user_id
      }
    }
  },

  mounted() {
    this.listenForClose()
  },

  methods: {
    listenForClose() {
      $(this.$el).on('hidden.bs.modal', this.reset)
    },

    submit() {
      if (!this.task) return;

      http.post(`/api/v2/retention-touchpoint-tasks/${this.task.id}/assign`, { user_id: this.selectedUserId })
          .then(() => {
            notify.success('Task successfully assigned.')
            this.$emit('assigned')
            $(this.$el).modal('hide')
          })
          .catch(this.catchValidationErrors)
    },

    reset() {
      this.errors = {}
      this.selectedUserId = null
    }
  }
}
</script>